module.exports = __webpack_public_path__ + "assets/img/Seniors-NZ-Content-Marketing-w720.c8eda2f8.webp";